















import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({
    inheritAttrs: false,
  })
  export default class StExplanation extends Vue {
    @Prop({default: 600})maxWidth!: number;
    @Prop({default: false})preserveWhitespace!: boolean;
  }
